module.exports = __webpack_public_path__ + "static/media/home-insider-img.10e5a859.jpg";